
import { ResponsiveIframe } from '../layouts/ResponsiveIframe.js';

export const ResearchGuide = {
  onLoad: function() {
    if ($('.single-resource_hub').length) {
      ResponsiveIframe.onLoad();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/ResearchGuide.js